import React from "react";

import classes from "./Pillar.module.css";

import rectangle50 from "../../images/pillars/rectangle50.png";

interface Props {
  data: { DESCRIPTION: string; ICON: string; INDEX: number; TITLE: string };
}

const Pillar = React.memo(({ data }: Props): JSX.Element => {
  const iconSource: string = data.ICON
    ? require("../../images/pillars/" + data.ICON)
    : false;

  let imgSize;
  switch (data.ICON) {
    case "mental.png":
      imgSize = { width: "120px", height: "185px" };
      break;
    case "heart.png":
      imgSize = { width: "145px", height: "145px" };
      break;
    case "lung.png":
      imgSize = { width: "130px", height: "130px" };
      break;
    case "posture.png":
      imgSize = { width: "140px", height: "210px" };
      break;
    case "cellular.png":
      imgSize = { width: "130px", height: "130px" };
      break;
    default:
      imgSize = { width: "140px", height: "140px" }; // Default size if not matched
  }

  return (
    <div className={classes.pillar}>
      <img
        className={classes.icon}
        style={imgSize}
        src={iconSource}
        alt="pillar icon"
      />
      <div className={classes.container}>
        <img
          className={classes.imgBackground}
          src={rectangle50}
          alt="background"
        />
        <div className={classes.pillarTitleHide}>{data.TITLE}</div>
        <div className={classes.descriptionHide}>{data.DESCRIPTION}</div>
        <div className={classes.inner}>
          <div className={classes.pillarTitle}>{data.TITLE}</div>
          <div className={classes.description}>{data.DESCRIPTION}</div>
        </div>
      </div>
    </div>
  );
});

export default Pillar;
